export type DateFormat = 'DD-MM-YYYY' | 'MM-DD-YYYY' | 'YYYY-MM-DD';

export interface Country {
  name: string;
  code: string;
  phoneCode: string;
  currency: string;
  currencySymbol: string;
  flag: string;
  dateFormat: DateFormat;
}

export const countries: Country[] = [
  { name: 'Afghanistan', code: 'AF', phoneCode: '+93', currency: 'AFN', currencySymbol: '؋', flag: '🇦🇫', dateFormat: 'DD-MM-YYYY' },
  { name: 'Albania', code: 'AL', phoneCode: '+355', currency: 'ALL', currencySymbol: 'L', flag: '🇦🇱', dateFormat: 'DD-MM-YYYY' },
  { name: 'Algeria', code: 'DZ', phoneCode: '+213', currency: 'DZD', currencySymbol: 'د.ج', flag: '🇩🇿', dateFormat: 'DD-MM-YYYY' },
  { name: 'Argentina', code: 'AR', phoneCode: '+54', currency: 'ARS', currencySymbol: '$', flag: '🇦🇷', dateFormat: 'DD-MM-YYYY' },
  { name: 'Australia', code: 'AU', phoneCode: '+61', currency: 'AUD', currencySymbol: 'A$', flag: '🇦🇺', dateFormat: 'DD-MM-YYYY' },
  { name: 'Austria', code: 'AT', phoneCode: '+43', currency: 'EUR', currencySymbol: '€', flag: '🇦🇹', dateFormat: 'DD-MM-YYYY' },
  { name: 'Bahrain', code: 'BH', phoneCode: '+973', currency: 'BHD', currencySymbol: 'ب.د', flag: '🇧🇭', dateFormat: 'DD-MM-YYYY' },
  { name: 'Bangladesh', code: 'BD', phoneCode: '+880', currency: 'BDT', currencySymbol: '৳', flag: '🇧🇩', dateFormat: 'DD-MM-YYYY' },
  { name: 'Belgium', code: 'BE', phoneCode: '+32', currency: 'EUR', currencySymbol: '€', flag: '🇧🇪', dateFormat: 'DD-MM-YYYY' },
  { name: 'Brazil', code: 'BR', phoneCode: '+55', currency: 'BRL', currencySymbol: 'R$', flag: '🇧🇷', dateFormat: 'DD-MM-YYYY' },
  { name: 'Canada', code: 'CA', phoneCode: '+1', currency: 'CAD', currencySymbol: 'C$', flag: '🇨🇦', dateFormat: 'MM-DD-YYYY' },
  { name: 'Chile', code: 'CL', phoneCode: '+56', currency: 'CLP', currencySymbol: '$', flag: '🇨🇱', dateFormat: 'DD-MM-YYYY' },
  { name: 'China', code: 'CN', phoneCode: '+86', currency: 'CNY', currencySymbol: '¥', flag: '🇨🇳', dateFormat: 'YYYY-MM-DD' },
  { name: 'Colombia', code: 'CO', phoneCode: '+57', currency: 'COP', currencySymbol: '$', flag: '🇨🇴', dateFormat: 'DD-MM-YYYY' },
  { name: 'Czech Republic', code: 'CZ', phoneCode: '+420', currency: 'CZK', currencySymbol: 'Kč', flag: '🇨🇿', dateFormat: 'DD-MM-YYYY' },
  { name: 'Denmark', code: 'DK', phoneCode: '+45', currency: 'DKK', currencySymbol: 'kr', flag: '🇩🇰', dateFormat: 'DD-MM-YYYY' },
  { name: 'Egypt', code: 'EG', phoneCode: '+20', currency: 'EGP', currencySymbol: '£', flag: '🇪🇬', dateFormat: 'DD-MM-YYYY' },
  { name: 'Finland', code: 'FI', phoneCode: '+358', currency: 'EUR', currencySymbol: '€', flag: '🇫🇮', dateFormat: 'DD-MM-YYYY' },
  { name: 'France', code: 'FR', phoneCode: '+33', currency: 'EUR', currencySymbol: '€', flag: '🇫🇷', dateFormat: 'DD-MM-YYYY' },
  { name: 'Germany', code: 'DE', phoneCode: '+49', currency: 'EUR', currencySymbol: '€', flag: '🇩🇪', dateFormat: 'DD-MM-YYYY' },
  { name: 'Greece', code: 'GR', phoneCode: '+30', currency: 'EUR', currencySymbol: '€', flag: '🇬🇷', dateFormat: 'DD-MM-YYYY' },
  { name: 'Hong Kong', code: 'HK', phoneCode: '+852', currency: 'HKD', currencySymbol: 'HK$', flag: '🇭🇰', dateFormat: 'DD-MM-YYYY' },
  { name: 'Hungary', code: 'HU', phoneCode: '+36', currency: 'HUF', currencySymbol: 'Ft', flag: '🇭🇺', dateFormat: 'YYYY-MM-DD' },
  { name: 'Iceland', code: 'IS', phoneCode: '+354', currency: 'ISK', currencySymbol: 'kr', flag: '🇮🇸', dateFormat: 'DD-MM-YYYY' },
  { name: 'India', code: 'IN', phoneCode: '+91', currency: 'INR', currencySymbol: '₹', flag: '🇮🇳', dateFormat: 'DD-MM-YYYY' },
  { name: 'Indonesia', code: 'ID', phoneCode: '+62', currency: 'IDR', currencySymbol: 'Rp', flag: '🇮🇩', dateFormat: 'DD-MM-YYYY' },
  { name: 'Ireland', code: 'IE', phoneCode: '+353', currency: 'EUR', currencySymbol: '€', flag: '🇮🇪', dateFormat: 'DD-MM-YYYY' },
  { name: 'Israel', code: 'IL', phoneCode: '+972', currency: 'ILS', currencySymbol: '₪', flag: '🇮🇱', dateFormat: 'DD-MM-YYYY' },
  { name: 'Italy', code: 'IT', phoneCode: '+39', currency: 'EUR', currencySymbol: '€', flag: '🇮🇹', dateFormat: 'DD-MM-YYYY' },
  { name: 'Japan', code: 'JP', phoneCode: '+81', currency: 'JPY', currencySymbol: '¥', flag: '🇯🇵', dateFormat: 'YYYY-MM-DD' },
  { name: 'Jordan', code: 'JO', phoneCode: '+962', currency: 'JOD', currencySymbol: 'د.ا', flag: '🇯🇴', dateFormat: 'DD-MM-YYYY' },
  { name: 'Kenya', code: 'KE', phoneCode: '+254', currency: 'KES', currencySymbol: 'KSh', flag: '🇰🇪', dateFormat: 'DD-MM-YYYY' },
  { name: 'Kuwait', code: 'KW', phoneCode: '+965', currency: 'KWD', currencySymbol: 'د.ك', flag: '🇰🇼', dateFormat: 'DD-MM-YYYY' },
  { name: 'Lebanon', code: 'LB', phoneCode: '+961', currency: 'LBP', currencySymbol: 'ل.ل', flag: '🇱🇧', dateFormat: 'DD-MM-YYYY' },
  { name: 'Malaysia', code: 'MY', phoneCode: '+60', currency: 'MYR', currencySymbol: 'RM', flag: '🇲🇾', dateFormat: 'DD-MM-YYYY' },
  { name: 'Mexico', code: 'MX', phoneCode: '+52', currency: 'MXN', currencySymbol: '$', flag: '🇲🇽', dateFormat: 'DD-MM-YYYY' },
  { name: 'Morocco', code: 'MA', phoneCode: '+212', currency: 'MAD', currencySymbol: 'د.م.', flag: '🇲🇦', dateFormat: 'DD-MM-YYYY' },
  { name: 'Netherlands', code: 'NL', phoneCode: '+31', currency: 'EUR', currencySymbol: '€', flag: '🇳🇱', dateFormat: 'DD-MM-YYYY' },
  { name: 'New Zealand', code: 'NZ', phoneCode: '+64', currency: 'NZD', currencySymbol: 'NZ$', flag: '🇳🇿', dateFormat: 'DD-MM-YYYY' },
  { name: 'Nigeria', code: 'NG', phoneCode: '+234', currency: 'NGN', currencySymbol: '₦', flag: '🇳🇬', dateFormat: 'DD-MM-YYYY' },
  { name: 'Norway', code: 'NO', phoneCode: '+47', currency: 'NOK', currencySymbol: 'kr', flag: '🇳🇴', dateFormat: 'DD-MM-YYYY' },
  { name: 'Oman', code: 'OM', phoneCode: '+968', currency: 'OMR', currencySymbol: 'ر.ع.', flag: '🇴🇲', dateFormat: 'DD-MM-YYYY' },
  { name: 'Pakistan', code: 'PK', phoneCode: '+92', currency: 'PKR', currencySymbol: '₨', flag: '🇵🇰', dateFormat: 'DD-MM-YYYY' },
  { name: 'Peru', code: 'PE', phoneCode: '+51', currency: 'PEN', currencySymbol: 'S/', flag: '🇵🇪', dateFormat: 'DD-MM-YYYY' },
  { name: 'Philippines', code: 'PH', phoneCode: '+63', currency: 'PHP', currencySymbol: '₱', flag: '🇵🇭', dateFormat: 'MM-DD-YYYY' },
  { name: 'Poland', code: 'PL', phoneCode: '+48', currency: 'PLN', currencySymbol: 'zł', flag: '🇵🇱', dateFormat: 'DD-MM-YYYY' },
  { name: 'Portugal', code: 'PT', phoneCode: '+351', currency: 'EUR', currencySymbol: '€', flag: '🇵🇹', dateFormat: 'DD-MM-YYYY' },
  { name: 'Qatar', code: 'QA', phoneCode: '+974', currency: 'QAR', currencySymbol: 'ر.ق', flag: '🇶🇦', dateFormat: 'DD-MM-YYYY' },
  { name: 'Romania', code: 'RO', phoneCode: '+40', currency: 'RON', currencySymbol: 'lei', flag: '🇷🇴', dateFormat: 'DD-MM-YYYY' },
  { name: 'Russia', code: 'RU', phoneCode: '+7', currency: 'RUB', currencySymbol: '₽', flag: '🇷🇺', dateFormat: 'DD-MM-YYYY' },
  { name: 'Saudi Arabia', code: 'SA', phoneCode: '+966', currency: 'SAR', currencySymbol: 'ر.س', flag: '🇸🇦', dateFormat: 'DD-MM-YYYY' },
  { name: 'Singapore', code: 'SG', phoneCode: '+65', currency: 'SGD', currencySymbol: 'S$', flag: '🇸🇬', dateFormat: 'DD-MM-YYYY' },
  { name: 'South Africa', code: 'ZA', phoneCode: '+27', currency: 'ZAR', currencySymbol: 'R', flag: '🇿🇦', dateFormat: 'DD-MM-YYYY' },
  { name: 'South Korea', code: 'KR', phoneCode: '+82', currency: 'KRW', currencySymbol: '₩', flag: '🇰🇷', dateFormat: 'YYYY-MM-DD' },
  { name: 'Spain', code: 'ES', phoneCode: '+34', currency: 'EUR', currencySymbol: '€', flag: '🇪🇸', dateFormat: 'DD-MM-YYYY' },
  { name: 'Sri Lanka', code: 'LK', phoneCode: '+94', currency: 'LKR', currencySymbol: 'Rs', flag: '🇱🇰', dateFormat: 'DD-MM-YYYY' },
  { name: 'Sweden', code: 'SE', phoneCode: '+46', currency: 'SEK', currencySymbol: 'kr', flag: '🇸🇪', dateFormat: 'YYYY-MM-DD' },
  { name: 'Switzerland', code: 'CH', phoneCode: '+41', currency: 'CHF', currencySymbol: 'CHF', flag: '🇨🇭', dateFormat: 'DD-MM-YYYY' },
  { name: 'Taiwan', code: 'TW', phoneCode: '+886', currency: 'TWD', currencySymbol: 'NT$', flag: '🇹🇼', dateFormat: 'YYYY-MM-DD' },
  { name: 'Thailand', code: 'TH', phoneCode: '+66', currency: 'THB', currencySymbol: '฿', flag: '🇹🇭', dateFormat: 'DD-MM-YYYY' },
  { name: 'Turkey', code: 'TR', phoneCode: '+90', currency: 'TRY', currencySymbol: '₺', flag: '🇹🇷', dateFormat: 'DD-MM-YYYY' },
  { name: 'Ukraine', code: 'UA', phoneCode: '+380', currency: 'UAH', currencySymbol: '₴', flag: '🇺🇦', dateFormat: 'DD-MM-YYYY' },
  { name: 'United Arab Emirates', code: 'AE', phoneCode: '+971', currency: 'AED', currencySymbol: 'د.إ', flag: '🇦🇪', dateFormat: 'DD-MM-YYYY' },
  { name: 'United Kingdom', code: 'GB', phoneCode: '+44', currency: 'GBP', currencySymbol: '£', flag: '🇬🇧', dateFormat: 'DD-MM-YYYY' },
  { name: 'United States', code: 'US', phoneCode: '+1', currency: 'USD', currencySymbol: '$', flag: '🇺🇸', dateFormat: 'MM-DD-YYYY' },
  { name: 'Vietnam', code: 'VN', phoneCode: '+84', currency: 'VND', currencySymbol: '₫', flag: '🇻🇳', dateFormat: 'DD-MM-YYYY' },
];

// Helper functions
export const getCountryByCode = (code: string): Country | undefined => {
  return countries.find(c => c.code === code);
};

export const getCountryByPhoneCode = (phoneCode: string): Country | undefined => {
  return countries.find(c => c.phoneCode === phoneCode);
};

export const getCountryByCurrency = (currency: string): Country | undefined => {
  return countries.find(c => c.currency === currency);
};

// Get unique currencies
export const getCurrencies = (): { code: string; symbol: string; countries: string[] }[] => {
  const currencyMap = new Map<string, { symbol: string; countries: string[] }>();

  countries.forEach(country => {
    if (currencyMap.has(country.currency)) {
      currencyMap.get(country.currency)!.countries.push(country.name);
    } else {
      currencyMap.set(country.currency, { symbol: country.currencySymbol, countries: [country.name] });
    }
  });

  return Array.from(currencyMap.entries())
    .map(([code, data]) => ({ code, symbol: data.symbol, countries: data.countries }))
    .sort((a, b) => a.code.localeCompare(b.code));
};

// Currency name mapping for all currencies
export const currencyNames: { [key: string]: string } = {
  AED: 'UAE Dirham',
  AFN: 'Afghan Afghani',
  ALL: 'Albanian Lek',
  ARS: 'Argentine Peso',
  AUD: 'Australian Dollar',
  BDT: 'Bangladeshi Taka',
  BHD: 'Bahraini Dinar',
  BRL: 'Brazilian Real',
  CAD: 'Canadian Dollar',
  CHF: 'Swiss Franc',
  CLP: 'Chilean Peso',
  CNY: 'Chinese Yuan',
  COP: 'Colombian Peso',
  CZK: 'Czech Koruna',
  DKK: 'Danish Krone',
  DZD: 'Algerian Dinar',
  EGP: 'Egyptian Pound',
  EUR: 'Euro',
  GBP: 'British Pound',
  HKD: 'Hong Kong Dollar',
  HUF: 'Hungarian Forint',
  IDR: 'Indonesian Rupiah',
  ILS: 'Israeli Shekel',
  INR: 'Indian Rupee',
  ISK: 'Icelandic Krona',
  JOD: 'Jordanian Dinar',
  JPY: 'Japanese Yen',
  KES: 'Kenyan Shilling',
  KRW: 'South Korean Won',
  KWD: 'Kuwaiti Dinar',
  LBP: 'Lebanese Pound',
  LKR: 'Sri Lankan Rupee',
  MAD: 'Moroccan Dirham',
  MXN: 'Mexican Peso',
  MYR: 'Malaysian Ringgit',
  NGN: 'Nigerian Naira',
  NOK: 'Norwegian Krone',
  NZD: 'New Zealand Dollar',
  OMR: 'Omani Rial',
  PEN: 'Peruvian Sol',
  PHP: 'Philippine Peso',
  PKR: 'Pakistani Rupee',
  PLN: 'Polish Zloty',
  QAR: 'Qatari Riyal',
  RON: 'Romanian Leu',
  RUB: 'Russian Ruble',
  SAR: 'Saudi Riyal',
  SEK: 'Swedish Krona',
  SGD: 'Singapore Dollar',
  THB: 'Thai Baht',
  TRY: 'Turkish Lira',
  TWD: 'Taiwan Dollar',
  UAH: 'Ukrainian Hryvnia',
  USD: 'US Dollar',
  VND: 'Vietnamese Dong',
  ZAR: 'South African Rand',
};

// Generate all currencies from countries data with names
export const getAllCurrencies = (): { code: string; symbol: string; name: string }[] => {
  const currencyMap = new Map<string, string>();

  countries.forEach(country => {
    if (!currencyMap.has(country.currency)) {
      currencyMap.set(country.currency, country.currencySymbol);
    }
  });

  return Array.from(currencyMap.entries())
    .map(([code, symbol]) => ({
      code,
      symbol,
      name: currencyNames[code] || code,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
};

// All currencies - pre-generated for convenience
export const allCurrencies = getAllCurrencies();

// Common currencies for quick selection (kept for backwards compatibility)
export const commonCurrencies = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham' },
  { code: 'SAR', symbol: 'ر.س', name: 'Saudi Riyal' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan' },
  { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar' },
  { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc' },
];

// Date format options
export const dateFormats: { value: DateFormat; label: string; example: string }[] = [
  { value: 'DD-MM-YYYY', label: 'DD-MM-YYYY', example: '25-12-2025' },
  { value: 'MM-DD-YYYY', label: 'MM-DD-YYYY', example: '12-25-2025' },
  { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD', example: '2025-12-25' },
];

// Get date format for a country
export const getDateFormatByCountry = (countryCode: string): DateFormat => {
  const country = getCountryByCode(countryCode);
  return country?.dateFormat || 'DD-MM-YYYY';
};

// Format a date string or Date object according to the specified format
export const formatDate = (date: string | Date, format: DateFormat = 'DD-MM-YYYY'): string => {
  const d = typeof date === 'string' ? new Date(date) : date;

  if (isNaN(d.getTime())) {
    return '';
  }

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  switch (format) {
    case 'DD-MM-YYYY':
      return `${day}-${month}-${year}`;
    case 'MM-DD-YYYY':
      return `${month}-${day}-${year}`;
    case 'YYYY-MM-DD':
      return `${year}-${month}-${day}`;
    default:
      return `${day}-${month}-${year}`;
  }
};

// Parse a date string from a specific format to a Date object
export const parseDate = (dateStr: string, format: DateFormat = 'DD-MM-YYYY'): Date | null => {
  if (!dateStr) return null;

  const parts = dateStr.split('-');
  if (parts.length !== 3) return null;

  let day: number, month: number, year: number;

  switch (format) {
    case 'DD-MM-YYYY':
      day = parseInt(parts[0], 10);
      month = parseInt(parts[1], 10) - 1;
      year = parseInt(parts[2], 10);
      break;
    case 'MM-DD-YYYY':
      month = parseInt(parts[0], 10) - 1;
      day = parseInt(parts[1], 10);
      year = parseInt(parts[2], 10);
      break;
    case 'YYYY-MM-DD':
      year = parseInt(parts[0], 10);
      month = parseInt(parts[1], 10) - 1;
      day = parseInt(parts[2], 10);
      break;
    default:
      return null;
  }

  const date = new Date(year, month, day);
  if (isNaN(date.getTime())) return null;

  return date;
};

// Convert date from one format to another
export const convertDateFormat = (dateStr: string, fromFormat: DateFormat, toFormat: DateFormat): string => {
  const date = parseDate(dateStr, fromFormat);
  if (!date) return dateStr;
  return formatDate(date, toFormat);
};

// Convert display format (DD-MM-YYYY etc.) to API format (YYYY-MM-DD)
export const toApiDateFormat = (dateStr: string, fromFormat: DateFormat): string => {
  const date = parseDate(dateStr, fromFormat);
  if (!date) return dateStr;
  return formatDate(date, 'YYYY-MM-DD');
};

// Convert API format (YYYY-MM-DD) to display format
export const fromApiDateFormat = (dateStr: string, toFormat: DateFormat): string => {
  // API always sends YYYY-MM-DD format
  const date = parseDate(dateStr, 'YYYY-MM-DD');
  if (!date) return dateStr;
  return formatDate(date, toFormat);
};
